import { useEffect } from "react";
import Keycloak from "keycloak-js";
import { useDispatch, useSelector, keycloakActions } from "src/redux/store";

const KeycloakAuth = ({ children }) => {
    const dispatch = useDispatch();
    const { keycloak } = useSelector((state) => state.keycloakReducer);

    const init = async () => {
        if (Object.keys(keycloak).length) return;
        const kc = new Keycloak({
            url: process.env.REACT_APP_LOGIN_URL,
            realm: process.env.REACT_APP_LOGIN_REALM,
            clientId: process.env.REACT_APP_LOGIN_CLIENT_ID
        });
        kc.onReady = () => {
            dispatch(keycloakActions.setKeycloak(kc));
        };
        kc.onAuthError = (e, a) => {
            console.log("[KC]: onAuthError=", e, a);
            kc.clearToken();
        };
        kc.onAuthRefreshError = (e, a) => {
            console.log("[KC]: onAuthRefreshError=", e, a);
            kc.clearToken();
        };
        kc.onTokenExpired = async () => {
            const result = await kc.updateToken();
            console.log("[KC]: updateToken=", result);
            if (result) {
                // TODO
            } else {
                kc.clearToken();
            }
        };
        kc.onAuthLogout = () => {
            kc.logout();
        };
        kc.init({
            onLoad: "check-sso",
            pkceMethod: "S256"
        });
    };

    useEffect(() => {
        init();
    }, []);

    return children;
};
export default KeycloakAuth;
